import { useField } from "formik";
import { DisplayFieldErrors, useTableSelection } from "melco-shared-logic";
import { BulkActionContainerCol, FullWidthSpace } from "melco-ui";
import { BulkActionCount } from "../../table/BulkActionCount";
import { BulkActionRemoveHoopProducts } from "../BulkActionRemoveHoopProducts";
import { HoopProductList } from "../HoopProductList";

type HoopProductsTabProps = {
}


export const HoopProductsTab: React.FC<HoopProductsTabProps> = () => {
    const { selectedRowKeys, setSelectedRowKeys, rowSelection } = useTableSelection<any>(() => { });
    const [{ value: hoopProducts }] = useField<any[]>("product_list");


    return <>

        <DisplayFieldErrors name="product_list" />
        <BulkActionContainerCol >
            <BulkActionCount selectedCount={selectedRowKeys.length} />
            <BulkActionRemoveHoopProducts
                data={hoopProducts}
                selectedRowKeys={selectedRowKeys}
                setSelectedRowKeys={setSelectedRowKeys}
            />
        </BulkActionContainerCol>


        <FullWidthSpace size="small" direction="vertical">
            <HoopProductList />
        </FullWidthSpace>

    </>
}